/** Client route paths (hash router). Kept in one place for deep-link mapping. */
export const ROUTES = {
  splash: '/',
  login: '/login',
  register: '/register',
  underReview: '/under-review',
  blocked: '/blocked',
  forceUpdate: '/update-required',
  home: '/home',
  category: (name: string) => `/category/${encodeURIComponent(name)}`,
  categoryPattern: '/category/:name',
  product: (id: string) => `/product/${encodeURIComponent(id)}`,
  saved: '/saved',
  productPattern: '/product/:id',
  profile: '/profile',
  /** Scratch & win card (one per dealer per round, when the admin has it on). */
  scratch: '/scratch',
} as const;
